<template>
    <div class="sheduleWrap">
        <div class="sheduleItem">
            <router-link v-bind:to="spielplan.route">
                <div class="row text-base font-bold gradientText">
                    <div class="cell gradientText py-8 px-6">
                        <img v-bind:src="spielplan.fahne_home" class="flag mb-2">
                        <div class="block">
                            <div class="text-6xl py-3 inline">
                                {{spielplan.home_tore}}
                            </div>
                        </div>
                        <div class="truncate">
                            <the-language :de="spielplan.home_de" :en="spielplan.home_en" />
                        </div>
                    </div>
                    <div class="cell gradientText py-8 px-6">
                        <img v-bind:src="spielplan.fahne_away" class="flag mb-2">
                        <div class="block">
                            <div class="text-6xl py-3 inline">
                                {{spielplan.away_tore}}
                            </div>
                        </div>
                        <div class="truncate">
                            <the-language :de="spielplan.away_en" :en="spielplan.away_de" />
                        </div>
                    </div>
                    <div class="row text-primary-orange p-4 text-xs">
                        <the-language :de="spielplan.sport_name_de" :en="spielplan.sport_name_en" />
                        <span v-if="spielplan.alter_name_de">|</span>
                        <the-language :de="spielplan.alter_name_de" :en="spielplan.alter_name_en" />
                    </div>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>

    import TheLanguage from '../TheLanguage'

    export default {
        name: 'SpielplanTeaser',
        components: {
            TheLanguage
        },
        data() {
            return {

            }
        },

        props: {
            spielplan: {
                type: Object,
                default: () => {
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .flag{
        width: 20%;
        display: inline-block;
    }
    .sheduleWrap{
        text-align: center;
        width: 100vw;
    }
    .sheduleItem{
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.6);
        width: 90vw;
        @screen md {
            width: 80vw;
            max-width: 900px;
        }

        margin-top: 15px;
        margin-bottom: 15px;
        display: inline-block;
        position: relative;

        &:before,
        &:after{
            content: '';
            width: 8px;
            height: 40px;
            position: absolute;
        }
        &:before{
            @apply bg-primary-orange;
            left: 0;
            top: 0;
        }
        &:after{
            @apply bg-primary-blue;
            right: 0px;
            bottom: 0;
        }
    }
    .row{
        text-align: center;
    }
    .cell{
        display: inline-block;
        width: calc(50% - 1px);
        position: relative;
        &:first-child{
            border-right: 2px solid #f8b234;
            &:before{
                color: #368dc7;
                content: 'vs';
                -webkit-text-fill-color: #368dc7;
                border: 2px solid #f8b234;
                background: #FFF;
                border-radius: 100%;
                padding: 0;
                position: absolute;
                right: -25px;
                width: 50px;
                height: 50px;
                font-size: 30px;
                line-height: 45px;
                top: 50%;
                font-weight: lighter;
                margin-top: -25px;
            }
        }
        border-bottom: 1px solid #f8b234;
    }
</style>
